import React from "react";

const TermsOfService = () => (
  <main
    className="terms-of-service-page"
    style={{
      maxWidth: "820px",
      margin: "0 auto",
      padding: "2rem 1rem",
      fontFamily: "Inter, sans-serif",
      color: "#f6f7f9", // Light text color for all
      background: "inherit",
    }}


  >

    <div style={{ margin: "1.2rem 0 2.5rem 0" }}>
      <a
        href="/"
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "rgba(140,153,253,0.12)",
          color: "#8c99fd",
          fontWeight: 500,
          borderRadius: "32px",
          fontSize: "1rem",
          padding: "8px 20px 8px 14px",
          textDecoration: "none",
          border: "1px solid #283360",
          boxShadow: "0 1px 7px 0 rgba(44,54,98,0.06)",
          transition: "background 0.15s,border 0.15s",
          gap: "0.6em",
        }}
      >
        <svg width="17" height="17" viewBox="0 0 18 18" fill="none" style={{ marginRight: 6 }} xmlns="http://www.w3.org/2000/svg">
          <path d="M11.25 14.25L6.75 9.75L11.25 5.25" stroke="#8c99fd" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back to Home
      </a>
    </div>



    {/* Terms of Service Content */}
    <section style={{ margin: "3.5rem 0 3.5rem 0", color: "#f6f7f9" }}>
      <h1
        style={{
          fontWeight: 800,
          fontSize: "2.3rem",
          marginBottom: "1.7rem",
          color: "#f6f7f9", // Light heading color
          letterSpacing: "-0.03em"
        }}
      >
        Terms of Service
      </h1>
      <p
        style={{
          fontSize: "1.09rem",
          marginBottom: "2rem",
          color: "#dde6fa", // Light body color
          lineHeight: 1.7
        }}
      >
        Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the devyugal.in website ("Service") operated by Yugal Raj Vimal.
      </p>

      <h2 style={sectionHeading}>1. Acceptance of Terms</h2>
      <p style={sectionText}>
        By accessing or using this website, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.
      </p>

      <h2 style={sectionHeading}>2. Use of the Service</h2>
      <p style={sectionText}>
        The Service and its content are for your information and personal use only. You agree not to misuse the website, engage in fraudulent activity or violate any applicable laws.
      </p>

      <h2 style={sectionHeading}>3. Intellectual Property</h2>
      <p style={sectionText}>
        All content, including text, graphics, logos, and code on devyugal.in is the property of Yugal Raj Vimal unless otherwise stated. You may not reproduce, distribute, or create derivative works without explicit written permission.
      </p>

      <h2 style={sectionHeading}>4. Disclaimer</h2>
      <p style={sectionText}>
        The Service is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. DevYugal.in does not guarantee the accuracy, completeness, or reliability of any information on the Service.
      </p>

      <h2 style={sectionHeading}>5. Limitation of Liability</h2>
      <p style={sectionText}>
        In no event shall DevYugal.in or its owner be liable for any indirect, incidental, or consequential damages resulting from your use of (or inability to use) the Service.
      </p>

      <h2 style={sectionHeading}>6. Changes to Terms</h2>
      <p style={sectionText}>
        We reserve the right to update or change our Terms of Service at any time. Changes will be posted on this page with an updated effective date.
      </p>

      <h2 style={sectionHeading}>7. Contact</h2>
      <p style={sectionText}>
        If you have any questions about these Terms, please{" "}
        <a
          style={{ color: "#7ab8ff", textDecoration: "underline" }}
          href="mailto:yugal@devyugal.in"
        >
          contact us
        </a>
        .
      </p>
    </section>

    <footer
      style={{
        color: "#a9b1c6",
        textAlign: "center",
        marginTop: "3rem",
        fontSize: "0.97rem"
      }}
    >
      <p>
        For questions or data requests, email{" "}
        <a href="mailto:yugal@devyugal.in" style={{ color: "#77aaff" }}>
          yugal@devyugal.in
        </a>
        .<br />
        © 2025 Yugal Raj Vimal · devyugal.in
      </p>
    </footer>
  </main>
);

const sectionHeading = {
  fontWeight: 700,
  fontSize: "1.3rem",
  marginTop: "1.7em",
  marginBottom: ".5em",
  color: "#e2ecfb" // Light heading color
};

const sectionText = {
  lineHeight: 1.7,
  color: "#e6e9f2", // Light section text color
  marginBottom: ".8em",
  fontSize: "1.05rem"
};

export default TermsOfService;